import {all, AllEffect, fork} from 'redux-saga/effects';
import {initSaga} from "./initResModelSaga";
import {actionSaga} from "./gameResModelSaga";
import {spinSaga} from "./spinResModelSaga";
import {spinCascadeSaga} from "./spinCascadeResModelSaga";
import {freeSpinSaga} from "./freeSpinResModelSaga";
import {increaseBetSaga} from "./increaseBetResModelSaga";
import {decreaseBetSaga} from "./decreaseBetResModelSaga";
import {maxBetSaga} from "./maxBetResModelSaga";
import {historySaga} from "./historyResponseModelSaga";
import {specificHistorySaga} from "./specificHistoryResponseModelSaga";


// not using this saga
export default function* gamerootSaga(): IterableIterator<AllEffect<any>> {
    yield all([
        fork(initSaga),
        fork(actionSaga),
        fork(spinSaga),
        fork(spinCascadeSaga),
        fork(increaseBetSaga),
        fork(decreaseBetSaga),
        fork(maxBetSaga),
        fork(freeSpinSaga),
        fork(historySaga),
        fork(specificHistorySaga),
    ]);
}
